import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import axiosInstance from "../../services/auth";
import { toast } from "react-toastify";
import ReportView from "./ReportView";
import { useCombinedContext } from "../../context/CombinedContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

const ReportList = () => {
  const [report, setReport] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [fromDate, setFromDate] = useState(""); // Start date for filtering
  const [toDate, setToDate] = useState(""); // End date for filtering
  const [status, setStatus] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);

  // console.log("Report",report)
  const [loading, setLoading] = useState(false);

  const { selectedCompany } = useCombinedContext();

  const companyId = selectedCompany?._id;

  // Get Report List

  const getReport = async () => {
    try {
      setLoading(true);
      const params = {};
      if (fromDate) params.start_date = fromDate;
      if (toDate) params.end_date = toDate;
      if (status) params.status = status;
      const response = await axiosInstance.get(
        `/report/${companyId}/datewise`,
        {
          params,
        },
      );
      setReport(response.data.data || []);
      setFilterData(response.data.data || []);
    } catch (error) {
      // console.error("Error fetching report:", error);
      toast.error("Error fetching report:");
    } finally {
      setLoading(false);
    }
  };

  // Filter Job Location
  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = report.filter(
      (report) =>
        report.project_code?.vessel_code
          .toString()
          .toLowerCase()
          .includes(searchText) ||
        report.project_code?.vessel_name
          .toString()
          .toLowerCase()
          .includes(searchText) ||
        report.invoice_no?.toString().toLowerCase().includes(searchText) ||
        report.order_no?.toString().toLowerCase().includes(searchText) ||
        report.total_without_gst?.toString().toLowerCase().includes(searchText),
    );
    // console.log("filter data ", report);
    setFilterData(filteredLocation);
  };
  //Handle Page Location
  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // const itemsPerPage = 5;
  const currentReportItems = filterData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );

  const pageCount = Math.ceil(filterData.length / itemsPerPage);
  useEffect(() => {
    if (companyId) {
      getReport();
    }
  }, [companyId, fromDate, toDate, status]);

  const getInvoiceDateParts = (invoiceDate) => {
    const d = new Date(invoiceDate);

    if (!invoiceDate || Number.isNaN(d.getTime())) {
      return { invoiceDateText: "", month: "", year: "" };
    }

    return {
      invoiceDateText: d.toLocaleDateString("en-GB"),
      month: d.toLocaleString("en-US", { month: "long" }),
      year: String(d.getFullYear()),
    };
  };

  // Export to Excel
  /*   const handleExport = () => {
    const sheetData = [];
    const merges = [];

    // Add multi-row header
    sheetData.push([
      "Sl No",
      "company",
      "Company Code",
      "Project Name",
      "Invoice No",
      "Invoice Date",
      "Invoice Status",
      "Month",
      "Year",
      "Job No",
      "Work Order No",
      "Bill Items",
      "",
      "",
      "",
      "",
      "Sub Total",
    ]);
    sheetData.push([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Job No (Bill Items)",
      "Description",
      "Unit Price",
      "Quantity",
      "Amount",
      "",
    ]);

    // Merge header cells for "Bill Items"
    merges.push(
      { s: { r: 0, c: 11 }, e: { r: 0, c: 15 } }, // Merge "Bill Items"
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // Merge "Invoice No"
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Merge "Sl no"
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // Merge "Project Name"
      { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // Merge "Job No"
      { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } }, // Merge "Work Order No"
      { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // Merge "Work Order No"
      { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } }, // Merge "Work Order No"
      { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } }, // Invoice Date
      { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } }, // Month
      { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } }, // Year
      { s: { r: 0, c: 10 }, e: { r: 1, c: 10 } }, // Invoice Date
      { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } }, // Merge "Sub Total"
    );

    // Process each data object
    filterData.forEach((item, rowIndex) => {
      const startRow = sheetData.length; // Keep track of the starting row for merging
      const { invoiceDateText, month, year } = getInvoiceDateParts(
        item.invoice_date,
      );
      item.bill.forEach((billItem, billIndex) => {
        sheetData.push([
          rowIndex + 1 + billIndex, // Sl No
          billIndex === 0 ? item.company.company_name : "", // Merge Project Name
          billIndex === 0 ? item.company.company_code : "", // Merge Project Name
          billIndex === 0 ? item.project_code.vessel_name : "", // Merge Project Name
          billIndex === 0 ? item.invoice_no : "", // Merge Invoice No
          billIndex === 0 ? invoiceDateText : "",
          billIndex === 0 ? item.invoice_status : "", // Merge Invoice No
          billIndex === 0 ? month : "",
          billIndex === 0 ? year : "",
          billIndex === 0 ? item.project_code.vessel_code : "", // Merge Job No
          billIndex === 0 ? item.order_no : "", // Merge Work Order No
          billItem.job_no, // Bill Job No
          billItem.description, // Bill Description
          billItem.unit_price, // Bill Unit Price
          billItem.quantity, // Bill Quantity
          billItem.amount, // Bill Amount
          billIndex === 0 ? item.total_without_gst : "", // Merge Sub Total
        ]);
      });

      const endRow = sheetData.length - 1; // Last row for this item's bills

      // Merge cells for Project Name, Invoice No, Job No, Work Order No, and Sub Total
      if (item.bill.length > 1) {
        merges.push(
          { s: { r: startRow, c: 0 }, e: { r: endRow, c: 0 } }, // Project Name
          { s: { r: startRow, c: 1 }, e: { r: endRow, c: 1 } }, // Invoice No
          { s: { r: startRow, c: 2 }, e: { r: endRow, c: 2 } }, // Job No
          { s: { r: startRow, c: 3 }, e: { r: endRow, c: 3 } }, // Work Order No
          { s: { r: startRow, c: 4 }, e: { r: endRow, c: 4 } }, // Work Order No
          { s: { r: startRow, c: 5 }, e: { r: endRow, c: 5 } }, // Invoice Date
          { s: { r: startRow, c: 6 }, e: { r: endRow, c: 6 } }, // Month
          { s: { r: startRow, c: 7 }, e: { r: endRow, c: 7 } }, // Year
          { s: { r: startRow, c: 13 }, e: { r: endRow, c: 13 } }, // Sub Total
        );
      }
    });

    // Convert data to worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Apply merges to worksheet
    worksheet["!merges"] = merges;

    // Apply styles (borders and bold headers)
    Object.keys(worksheet).forEach((key) => {
      if (key[0] !== "!") {
        worksheet[key].s = {
          font: { bold: sheetData[0].includes(worksheet[key].v) }, // Make headers bold
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    // Create a new Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write and save to Excel
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(dataBlob, "exported_summary.xlsx");
  }; */
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // HEADER ROW 1
    worksheet.addRow([
      "Sl No",
      "Company",
      "Company Code",
      "Project Name",
      "Invoice No",
      "Invoice Date",
      "Invoice Status",
      "Month",
      "Year",
      "Job No",
      "Work Order No",
      "Bill Items",
      "",
      "",
      "",
      "",
      "Sub Total",
    ]);

    // HEADER ROW 2
    worksheet.addRow([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Job No (Bill Items)",
      "Description",
      "Unit Price",
      "Quantity",
      "Amount",
      "",
    ]);

    // ✅ MERGES (ExcelJS way)
    worksheet.mergeCells("L1:P1"); // Bill Items
    worksheet.mergeCells("A1:A2");
    worksheet.mergeCells("B1:B2");
    worksheet.mergeCells("C1:C2");
    worksheet.mergeCells("D1:D2");
    worksheet.mergeCells("E1:E2");
    worksheet.mergeCells("F1:F2");
    worksheet.mergeCells("G1:G2");
    worksheet.mergeCells("H1:H2");
    worksheet.mergeCells("I1:I2");
    worksheet.mergeCells("J1:J2");
    worksheet.mergeCells("K1:K2");
    worksheet.mergeCells("Q1:Q2");

    // STYLE HEADER
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    worksheet.getRow(2).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    let rowIndex = 3;

    filterData.forEach((item, index) => {
      const startRow = rowIndex;

      const { invoiceDateText, month, year } = getInvoiceDateParts(
        item.invoice_date,
      );

      item.bill.forEach((billItem, billIndex) => {
        const row = worksheet.addRow([
          billIndex === 0 ? index + 1 : "",
          billIndex === 0 ? item.company.company_name : "",
          billIndex === 0 ? item.company.company_code : "",
          billIndex === 0 ? item.project_code.vessel_name : "",
          billIndex === 0 ? item.invoice_no : "",
          billIndex === 0 ? invoiceDateText : "",
          billIndex === 0 ? item.invoice_status : "",
          billIndex === 0 ? month : "",
          billIndex === 0 ? year : "",
          billIndex === 0 ? toNumber(item.project_code.vessel_code) : "",
          billIndex === 0 ? toNumber(item.order_no) : "",
          toNumber(billItem.job_no),
          billItem.description,
          billItem.unit_price,
          billItem.quantity,
          billItem.amount,
          billIndex === 0 ? item.total_without_gst : "",
        ]);
        row.getCell(9).value = Number(year);
        worksheet.getColumn(10).numFmt = "@";
        // ✅ COLOR FOR INVOICE STATUS
        if (billIndex === 0) {
          const statusCell = row.getCell(7);

          let color = "";

          if (item.invoice_status === "pending") color = "FFFF00"; // Yellow
          if (item.invoice_status === "submitted") color = "FFA500"; // Orange
          if (item.invoice_status === "paid") color = "00FF00"; // Green

          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: color },
          };
        }

        rowIndex++;
      });

      const endRow = rowIndex - 1;

      // ✅ MERGE ROW DATA
      if (item.bill.length > 1) {
        const mergeCols = [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "Q",
        ];

        mergeCols.forEach((col) => {
          worksheet.mergeCells(`${col}${startRow}:${col}${endRow}`);
        });
      }
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "exported_summary.xlsx");
  };
  /*   const handleExportReport = () => {
    const sheetData = [];

    // Create a single header row without Bill Items columns
    sheetData.push([
      "Sl No",
      "company",
      "Company Code",
      "Project Name",
      "Invoice No",
      "Invoice Date",
      "Invoice Status",
      "Month",
      "Year",
      "Job No",
      "Work Order No",
      "Sub Total",
    ]);

    // Process each data object - one row per item (bill items removed)
    filterData.forEach((item, rowIndex) => {
      const { invoiceDateText, month, year } = getInvoiceDateParts(
        item.invoice_date,
      );
      sheetData.push([
        rowIndex + 1, // Sl No
        item.company.company_name, // Project Name
        item.company.company_code, // Project Name
        item.project_code.vessel_name, // Project Name
        item.invoice_no, // Invoice No
        invoiceDateText,
        item.invoice_status,
        month,
        year,
        item.project_code.vessel_code, // Job No
        item.order_no, // Work Order No
        item.total_without_gst, // Sub Total
      ]);
    });

    // Convert data to worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Apply styles (borders and bold headers)
    Object.keys(worksheet).forEach((key) => {
      if (key[0] !== "!") {
        worksheet[key].s = {
          font: { bold: sheetData[0].includes(worksheet[key].v) }, // Make headers bold
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    // Create a new Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write and save to Excel
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(dataBlob, "exported_data.xlsx");
  }; */
  const toNumber = (val) => {
    return val && !isNaN(val) ? Number(val) : val;
  };
  const handleExportReport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Header
    worksheet.addRow([
      "Sl No",
      "Company",
      "Company Code",
      "Project Name",
      "Invoice No",
      "Invoice Date",
      "Invoice Status",
      "Month",
      "Year",
      "Job No",
      "Work Order No",
      "Sub Total",
    ]);

    // Style header
    worksheet.getRow(1).font = { bold: true };
    worksheet.getColumn(10).numFmt = "@";
    // Add rows
    filterData.forEach((item, index) => {
      const { invoiceDateText, month, year } = getInvoiceDateParts(
        item.invoice_date,
      );

      const row = worksheet.addRow([
        index + 1,
        item.company.company_name,
        item.company.company_code,
        item.project_code.vessel_name,
        item.invoice_no,
        invoiceDateText,
        item.invoice_status,
        month,
        year,
        toNumber(item.project_code.vessel_code),
        toNumber(item.order_no),
        item.total_without_gst,
      ]);
      row.getCell(9).value = Number(year); // Year

      // 🎨 Apply color based on status (column 7)
      const statusCell = row.getCell(7);

      if (item.invoice_status === "pending") {
        statusCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFC7CE" }, // light red
        };
      } else if (item.invoice_status === "submitted") {
        statusCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFEB9C" }, // light yellow
        };
      } else if (item.invoice_status === "paid") {
        statusCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC6EFCE" }, // light green
        };
      }
    });

    // Auto width (optional but nice)
    worksheet.columns.forEach((col) => {
      col.width = 18;
    });

    // Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "exported_data.xlsx");
  };
  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;

  return (
    <div className="">
      <h4 className="headStyle">Report</h4>

      {/* Left Side: Search and Date Inputs */}
      <div className="headStyle d-flex flex-wrap mt-4 align-items-center gap-3">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <label style={{ width: "-webkit-fill-available" }}>From Data</label>
          <input
            className="form-control"
            type="date"
            placeholder="From Date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{
              border: "1px solid #1E2A5E",
              borderRadius: "8px",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <label style={{ width: "-webkit-fill-available" }} htmlFor="fromDate">
            To Data
          </label>
          <input
            className="form-control"
            type="date"
            placeholder="To Date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{
              border: "1px solid #1E2A5E",
              borderRadius: "8px",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <label>Status</label>
          <select
            className="form-select "
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{
              borderRadius: "8px",
            }}
          >
            <option value="">---Please Select Status---</option>
            <option value="pending">Pending</option>
            {["superadmin"].includes(userRole) && (
              <option value="paid">Paid</option>
            )}
            <option value="submitted">Submitted</option>
          </select>
        </div>
      </div>
      <div className="headStyle mt-4">
        <div className="d-flex mt-2 flex-wrap align-items-center gap-3 justify-content-between">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div>
              <input
                className="form-control"
                type="search"
                placeholder="Search..."
                style={{
                  maxWidth: "100%",
                  border: "1px solid #1E2A5E",
                  borderRadius: "8px",
                }}
                onChange={handleSearchChange}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="me-2 pt-1">Count</label>
              <select
                className="form-select no-arrow"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                style={{ width: "auto" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0px",
                minWidth: "70px",
              }}
            >
              <button className="button-2" onClick={handleExport}>
                Export Summary
              </button>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0px",
                minWidth: "70px",
              }}
            >
              <button className="button-2" onClick={handleExportReport}>
                Export Report
              </button>
            </div>
          </div>
        </div>

        {/* Right Side: Add Invoice Button */}

        <div
          className="my-3 rounded"
          style={{
            overflowX: "auto",
          }}
        >
          <table
            id="my-table"
            className="table table-bordered mb-0"
            style={{
              boxShadow:
                "0 0 1px rgba(0, 0, 0, 0.2), 0px 2px 4px rgba(0, 0, 0, 0.15)",
            }}
          >
            <thead className="t_head">
              <tr className="">
                <th className="">#</th>
                <th className="">Project Name</th>
                <th className="e">Invoice No</th>
                <th className="e">Invoice Date</th>

                <th className="">Job No</th>

                <th className="">Work Order No</th>
                <th className="">Sub Total</th>

                {["admin", "superadmin"].includes(userRole) && (
                  <>
                    <th className="align-middle">GST Amount</th>
                    <th className="align-middle">Total Amount</th>
                  </>
                )}
                <th>Status</th>
                <th className="text-center align-middle ">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentReportItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="7">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentReportItems &&
                        currentReportItems.map((report, index) => (
                          <tr key={report._id || index}>
                            <td>{currentPage * itemsPerPage + index + 1}</td>

                            <td>{report.project_code?.vessel_name || "N/A"}</td>

                            <td>{report.invoice_no || "N/A"}</td>
                            <td>
                              {report.invoice_date
                                ? new Date(
                                    report.invoice_date,
                                  ).toLocaleDateString()
                                : "N/A"}
                            </td>

                            <td>{report.project_code?.vessel_code || "N/A"}</td>
                            <td>{report.order_no || "N/A"}</td>

                            <td>
                              {`$ ${formatPrice(report.total_without_gst)}` ||
                                "N/A"}
                            </td>
                            {["admin", "superadmin"].includes(userRole) && (
                              <>
                                <td>
                                  {`$ ${formatPrice(report.gst_amount)}` ||
                                    "N/A"}
                                </td>
                                <td>
                                  {`$ ${formatPrice(report.total_with_gst)}` ||
                                    "N/A"}
                                </td>
                              </>
                            )}
                            <td>{report.invoice_status}</td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => {
                                    setSelectedData(report);
                                    setIsViewMode(true);
                                  }}
                                >
                                  <i className="bi bi-folder2-open"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />
        {isViewMode && (
          <ReportView
            report={selectedData}
            isViewMode={isViewMode}
            setIsViewMode={setIsViewMode}
          />
        )}
      </div>
    </div>
  );
};

export default ReportList;
